module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('div', {
    staticClass: "bet-name"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("translate")('normal_bet')))])]), _vm._v(" "), _c('div', {
    staticClass: "betting-inputs",
    attrs: {
      "id": "bet-area"
    }
  }, _vm._l((_vm.bettingInputs), function(index) {
    return _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.bettingSvc.ticket.input[index - 1]),
        expression: "bettingSvc.ticket.input[index-1]"
      }, {
        name: "normal-bet-validator",
        rawName: "v-normal-bet-validator"
      }],
      key: index,
      attrs: {
        "type": "number",
        "autocomplete": "off",
        "disabled": _vm.isBettingDisabled
      },
      domProps: {
        "value": (_vm.bettingSvc.ticket.input[index - 1])
      },
      on: {
        "keydown": [_vm.checkChars, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          $event.preventDefault();
          _vm.setFocus(index)
        }, function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
          $event.preventDefault();
          _vm.setFocus(index)
        }],
        "click": function($event) {
          _vm.setFocus(index, true)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.bettingSvc.ticket.input,
            $$idx = index - 1;
          if (!Array.isArray($$exp)) {
            _vm.bettingSvc.ticket.input[index - 1] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-860d0cb2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop/bets/NormalBet.vue
// module id = 406
// module chunks = 0